import { CircularProgress, Paper } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../core/store'
import useStyles from './StatsViewStyles'

interface IProps {
    loading: boolean;
}
export default function OccupancyRate(props: IProps) {
    const classes = useStyles()
    const occupancyRate: number = useSelector((state: IRootState) => state.dashboardReducer.occupancyRate)
    return (
        <Paper className={classes.dataCard}>
            <div className={classes.dataCardTitle}>
                Occupancy Rate
            </div>
            <div className={classes.dataCardValue}>
                {
                    props.loading ?
                        <CircularProgress />
                        :
                        <>
                            {occupancyRate.toFixed(2).toString()}%
                        </>
                }
            </div>
        </Paper>
    )
}